(function () {
  "use strict";

  var instances = new WeakMap();

  function destroy(el) {
    var inst = instances.get(el);
    if (!inst) return;
    try {
      inst.destroy(true, true);
    } catch (_) {}
    instances.delete(el);
  }

  function isWrittenTabVisible(root) {
    var panel = root.closest(".sv-reviews__panel");
    if (!panel) return true;
    return panel.offsetParent !== null;
  }

  function bump(inst) {
    if (!inst) return;
    requestAnimationFrame(function () {
      inst.update();
    });
  }

  function initWritten(root) {
    if (typeof Swiper === "undefined") return;

    var el = root.querySelector(".sv-reviews__written-swiper");
    if (!el) return;

    var slideCount = el.querySelectorAll(".swiper-slide").length;
    if (slideCount === 0) return;

    destroy(root);

    var pag = root.querySelector(".sv-reviews__written-pagination");
    var prev = root.querySelector(".sv-reviews__written-arrow--prev");
    var next = root.querySelector(".sv-reviews__written-arrow--next");

    var inst = new Swiper(el, {
      slidesPerView: 1.25,
      spaceBetween: 12,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      roundLengths: true,
      breakpoints: {
        900: {
          slidesPerView: 4,
          spaceBetween: 12
        }
      },
      pagination: pag
        ? {
            el: pag,
            clickable: true
          }
        : undefined,
      navigation:
        prev && next
          ? {
              prevEl: prev,
              nextEl: next
            }
          : undefined
    });

    instances.set(root, inst);

    if (isWrittenTabVisible(root)) {
      bump(inst);
    }
  }

  function initAll(container) {
    var scope = container || document;
    scope.querySelectorAll("[data-sv-reviews-written]").forEach(initWritten);
  }

  function onWrittenTabClick(e) {
    var btn = e.target.closest('[id^="sv-reviews-tab-written-"]');
    if (!btn) return;
    var section = btn.closest(".sv-reviews");
    if (!section) return;
    var root = section.querySelector("[data-sv-reviews-written]");
    if (!root) return;
    var inst = instances.get(root);
    if (inst) {
      setTimeout(function () {
        bump(inst);
      }, 50);
      return;
    }
    setTimeout(function () {
      initWritten(root);
    }, 50);
  }

  var listenersBound = false;

  function boot() {
    if (typeof Swiper === "undefined") {
      window.addEventListener("load", boot, { once: true });
      return;
    }
    if (!listenersBound) {
      document.addEventListener("click", onWrittenTabClick);
      listenersBound = true;
    }
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var target = event.target;
    if (!target) return;
    target.querySelectorAll("[data-sv-reviews-written]").forEach(function (root) {
      destroy(root);
      initWritten(root);
    });
    if (typeof Alpine !== "undefined" && typeof Alpine.initTree === "function") {
      Alpine.initTree(target);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
